<template lang="pug" src="./tabs-left.pug"></template>

<script>
export default {
  props: ['props'],
  data () {
    return {
      active: 0
    }
  }
}
</script>



// WEBPACK FOOTER //
// tabs-left.vue?2300b6aa